import { Store } from "../lib";
import { Invoice } from "../models";

export default class InvoicesStore extends Store {
  model = Invoice;
  baseWebURI = "/app/invoices";
}
